import {
  Code01Icon,
  Globe01Icon,
  PackageSearchIcon,
} from '@langchain/untitled-ui-icons';

export const TAGS_CATEGORY = 'Prompt Tags';

export const tagsByCategory = [
  {
    category: TAGS_CATEGORY,
    icon: <PackageSearchIcon />,
    tags: [
      'Agent simulations',
      'Agents',
      'Autonomous agents',
      'Chatbots',
      'Classification',
      'Code understanding',
      'Code writing',
      'Evaluation',
      'Extraction',
      'Interacting with APIs',
      'Multi-modal',
      'QA over documents',
      'Self-checking',
      'SQL',
      'Summarization',
      'Tagging',
    ],
  },
  {
    category: 'Type',
    icon: <Code01Icon className="text-brand-green-400" />,
    tags: ['StructuredPrompt', 'StringPromptTemplate', 'ChatPromptTemplate'],
  },
  {
    category: 'Language',
    icon: <Globe01Icon className="text-brand-green-400" />,
    tags: [
      // based on most common languages of users visiting langsmith docs
      'English',
      'Chinese',
      'Korean',
      'Spanish',
      'French',
      'Japanese',
      'Portuguese',
      'German',
      'Russian',
      'Italian',
      'Vietnamese',
      'Polish',
      'Turkish',
      'Dutch',
      'Ukrainian',
      'Hebrew',
      'Swedish',
      'Indonesian',
      'Czech',
      'Thai',
    ],
  },
];
